import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import UserLink from '../../../User/Link';
import AuthorWatchButton from '../../../Button/AuthorWatchButton';
import s from './Author.scss';
var Author = function (_a) {
    var author = _a.author, isOwner = _a.isOwner, _b = _a.withByline, withByline = _b === void 0 ? true : _b, className = _a.className;
    var t = useTranslation().t;
    if (!author) {
        return null;
    }
    return (React.createElement("div", { className: c(className) },
        withByline && (React.createElement("span", { className: s['by'] },
            t('deviation.details.by'),
            " ")),
        React.createElement(UserLink, { className: s['username'], usernameClassName: s['username-inner'], withTooltip: true, user: author }),
        !isOwner && React.createElement(AuthorWatchButton, { dsButton: true, author: author })));
};
Author.displayName = 'Author';
export default Author;
//# sourceMappingURL=Author.js.map